import { QUERIES } from '@repo/ui/queries';
import styled from 'styled-components';

import { FlexContainer } from 'styles/layouts';

export const Wrapper = styled(FlexContainer)`
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;

  ${QUERIES.largeTabletAndUp} {
    flex-direction: row;
  }
`;

export const ButtonWrapper = styled.div`
  width: 100%;

  ${QUERIES.largeTabletAndUp} {
    width: fit-content;
  }
`;

export const Image = styled.img`
  max-width: 100%;
  max-height: 100%;
  height: 100%;
  aspect-ratio: 1/1;
  min-width: 100%;

  flex-grow: 1;
  object-fit: contain;

  ${QUERIES.largeTabletAndUp} {
    min-height: 408px;
    aspect-ratio: auto;
  }
`;
